import React from 'react';
import './CoachingReviewScorecardDetails.styl';
import CircularProgress from 'components/pure/utils/CircularProgress';
import isNil from 'lodash/isNil';
import {RichText} from 'components/pure/utils/form/user-taggable-input/RichTextEditor';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';
import {getMuiV4Theme} from 'utils/css/themeUtils';

const TO_PERCENT = 100;

/**
 * compute scores to percents
 *  see ScorecardResultProducer.computeScores
 */
export function toPercentage(score, scoringScheme) {
  if (isNil(score)) return 0;
  if (scoringScheme === 'OneToThree') {
    switch (score) {
      case 1:
        return (1 * TO_PERCENT) / 3;
      case 3:
        return (2 * TO_PERCENT) / 3;
      default:
        return (score * TO_PERCENT) / 5;
    }
  } else if (scoringScheme === 'OneTwo') {
    switch (score) {
      case 3:
        return 50;
      default:
        return (score * TO_PERCENT) / 5;
    }
  } else {
    return (score * TO_PERCENT) / 5;
  }
}

export default class CoachingReviewScorecardDetails extends React.PureComponent {
  render() {
    const {contentDetailScore, questionMap, scoringScheme, isLivecoachingReviewFileupload} =
      this.props;
    const question = questionMap.get(contentDetailScore.scorecardQuestionId);
    if (!question || !scoringScheme) return null;

    const percentage = toPercentage(contentDetailScore.score, scoringScheme);

    const inner = (
      <div className="coaching-review-scorecard-details">
        <div className="score call-question">
          <div className="label">{question.text}</div>
          <div className="value rating">
            {isNil(contentDetailScore.score) ? (
              <div className="no-score">
                <span className="na-text">N/A</span>
              </div>
            ) : (
              <div className="score-ring">
                <CircularProgress
                  color={getMuiV4Theme().palette.primary.main}
                  percentage={percentage}
                />
                <span className="ring-label">{percentage.toFixed(0)}%</span>
              </div>
            )}
          </div>
        </div>
        {contentDetailScore.reason && (
          <div className="reason call-question">
            <div className="label">Reason:</div>
            <div className="value ">{contentDetailScore.reason}</div>
          </div>
        )}
        {contentDetailScore.comment && (
          <div className="comment call-question">
            <div className="label">Comment:</div>
            <RichText className="value" dangerousText={contentDetailScore.comment} />
          </div>
        )}
      </div>
    );

    return isLivecoachingReviewFileupload ? (
      <GenericTooltip
        hoverBehavior
        positionTop
        delay={TOOLTIP_DELAY}
        tooltip={
          <div>
            These are the scores from the live coaching session that apply to the current coaching
            plan.
          </div>
        }>
        {inner}
      </GenericTooltip>
    ) : (
      inner
    );
  }
}
